




















































































































import {Vue, Component, Prop} from "vue-property-decorator";
import html2canvas from "html2canvas";
import {FullSurveyType, SurveyTabType} from "@/types/surveyTab.type";

@Component({})
export default class RiskPrioritizationFooter extends Vue {
    private page = 1;
    private fileDataB64 = null;
    private previewImgUrl = null;
    saveDialog = false;
    userDefinedFileName: string | null = null;
    dataDownload: null | string = null;
    dataBlob: null | Blob = null;
    fulldata: FullSurveyType | null = null;

    @Prop() items!: any[];

    get paginationLength() {
        const activeitems = [];
        this.items.forEach(item => {
            if (item.show) {
                activeitems.push(item);
            }
        });
        return Math.ceil(activeitems.length / 3);
    }

    get voterRegistrationQuestions() {
        return this.$store.getters.voterRegistrationQuestions;
    }

    get pollbookPrepQuestions() {
        return this.$store.getters.pollbookPrepQuestions;
    }

    get pollbookUseQuestions() {
        return this.$store.getters.pollbookUseQuestions;
    }

    get ballotPrepQuestions() {
        return this.$store.getters.ballotPrepQuestions;
    }

    get votingMachinePrepQuestions() {
        return this.$store.getters.votingMachinePrepQuestions;
    }

    get votingMachineUseQuestions() {
        return this.$store.getters.votingMachineUseQuestions;
    }

    get tabulationPrepQuestions() {
        return this.$store.getters.tabulationPrepQuestions;
    }

    get precinctTabulationQuestions() {
        return this.$store.getters.precinctTabulationQuestions;
    }

    get centralTabulationQuestions() {
        return this.$store.getters.centralTabulationQuestions;
    }

    get aggregationQuestions() {
        return this.$store.getters.aggregationQuestions;
    }

    get websiteQuestions() {
        return this.$store.getters.websiteQuestions;
    }

    get isIE() {
        return this.$store.getters.isIE;
    }

    get fileName() {
        if (this.userDefinedFileName !== null) {
            return this.userDefinedFileName.toString() + ".txt";
        } else {
            return "data.txt";
        }
    }

    setUpSave() {
        this.fulldata = {
            voterRegistrationQuestions: this.voterRegistrationQuestions,
            pollbookPrepQuestions: this.pollbookPrepQuestions,
            pollbookUseQuestions: this.pollbookUseQuestions,
            ballotPrepQuestions: this.ballotPrepQuestions,
            votingMachinePrepQuestions: this.votingMachinePrepQuestions,
            votingMachineUseQuestions: this.votingMachineUseQuestions,
            tabulationPrepQuestions: this.tabulationPrepQuestions,
            precinctTabulationQuestions: this.precinctTabulationQuestions,
            centralTabulationQuestions: this.centralTabulationQuestions,
            aggregationQuestions: this.aggregationQuestions,
            websiteQuestions: this.websiteQuestions,
            voterRegistrationVisited: this.$store.getters
                .voterRegistrationVisited,
            pollbookPrepVisited: this.$store.getters.pollbookPrepVisited,
            pollbookUseVisited: this.$store.getters.pollbookUseVisited,
            ballotPrepVisited: this.$store.getters.ballotPrepVisited,
            votingMachinePrepVisited: this.$store.getters
                .votingMachinePrepVisited,
            votingMachineUseVisited: this.$store.getters
                .votingMachineUseVisited,
            tabulationPrepVisited: this.$store.getters.tabulationPrepVisited,
            precinctTabulationVisited: this.$store.getters
                .precinctTabulationVisited,
            centralTabulationVisited: this.$store.getters
                .centralTabulationVisited,
            aggregationVisited: this.$store.getters.aggregationVisited,
            websiteVisited: this.$store.getters.websiteVisited
        };

        this.saveDialog = true;

        this.dataBlob = new Blob([JSON.stringify(this.fulldata, null, 2)], {
            type: "text/plain"
        });

        this.dataDownload = URL.createObjectURL(this.dataBlob);
    }

    saveFile() {
        window.navigator.msSaveBlob(this.dataBlob, this.fileName);
        this.saveDialog = false;
    }

    goToEditSurvey() {
        window.scrollTo(0, 0);
        this.$router.push("/survey");
    }
}
